import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "tw-mb-2 tw-block tw-text-xs" }, " Shown as a loading screen before prerecorded videos start and after they end when switching back to live speakers. If a filler slide is not uploaded, a black Goldcast logo will show instead. Image size 1920x1080 ", -1)
const _hoisted_2 = {
  key: 0,
  class: "tw-mb-2 tw-block tw-text-xs"
}
const _hoisted_3 = { key: 2 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "tw-mb-4 tw-block tw-text-xs" }, "Select a file with an aspect ratio of 1920x1080", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StudioSpinner = _resolveComponent("StudioSpinner")!
  const _component_TablerPlus = _resolveComponent("TablerPlus")!
  const _component_StudioButton = _resolveComponent("StudioButton")!
  const _component_FillerSlideLibraryListItem = _resolveComponent("FillerSlideLibraryListItem")!
  const _component_FillerSlideLibraryDialog = _resolveComponent("FillerSlideLibraryDialog")!
  const _component_ModuleWrapper = _resolveComponent("ModuleWrapper")!

  return (_openBlock(), _createBlock(_component_ModuleWrapper, {
    moduleId: _ctx.moduleId,
    title: "Filler Slide",
    onInitializeData: _ctx.initializeData
  }, {
    main: _withCtx(() => [
      _hoisted_1,
      (_ctx.isFillerSlideDisabled)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Filler slide cannot be changed less than one hour before the start of the event "))
        : _createCommentVNode("", true),
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_StudioSpinner, {
            key: 1,
            coverContainer: false,
            size: "xsmall"
          }))
        : (!_ctx.selectedFillerSlideAsset)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _hoisted_4,
              _createVNode(_component_StudioButton, {
                trackingId: "select-filler-slide-button",
                variant: "outline",
                disabled: _ctx.isFillerSlideDisabled,
                disabledReason: 
            _ctx.isFillerSlideDisabled
              ? 'Filler slide cannot be changed less than one hour before the start of the event'
              : ''
          ,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showFillerSlideLibraryDialog = true))
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_TablerPlus)
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" Select Filler Slide ")
                ]),
                _: 1
              }, 8, ["disabled", "disabledReason"])
            ]))
          : (_openBlock(), _createBlock(_component_FillerSlideLibraryListItem, {
              key: 3,
              visibleActions: {
          openPreview: true,
          rename: true,
          remove: true
        },
              alwaysShowActions: "",
              fillerSlideAsset: _ctx.selectedFillerSlideAsset,
              isCtaDisabled: _ctx.isFillerSlideDisabled,
              onRemove: _ctx.handleFillerSlideRemoved,
              onRenameSuccess: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleRenameSuccess($event)))
            }, null, 8, ["fillerSlideAsset", "isCtaDisabled", "onRemove"])),
      (_ctx.showFillerSlideLibraryDialog)
        ? (_openBlock(), _createBlock(_component_FillerSlideLibraryDialog, {
            key: 4,
            title: "Select Filler Slide",
            maxSelections: 1,
            onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showFillerSlideLibraryDialog = false)),
            onSelectFillerSlides: _ctx.handleSelectFillerSlides
          }, null, 8, ["onSelectFillerSlides"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["moduleId", "onInitializeData"]))
}